import React, { useState } from 'react'
import './Crypto.css'

const data = [{id:1, name:"UNI",rate:"11.1",quantity:15,date:"2 april 2024", investment:172, current:180, roi:"3.1%"},{id:2, name:"UNI",rate:"11.1",quantity:15,date:"2 april 2024", investment:172, current:180, roi:"3.1%"},{id:3, name:"UNI",rate:"11.1",quantity:15,date:"2 april 2024", investment:172, current:180, roi:"3.1%"}];

const Crypto = () => {

  return (
    
    <div className='crypto-main-container'>
        <h1 className='text5'>Portfolio</h1>
        <table className='crypto-container'>
          <thead className='crypto-header'>
            <tr>
              <th>Sr. No.</th>
              <th>Name</th>
              <th>Current Rate</th>
              <th>Quantity</th>
              <th>Date</th>
              <th>Total Investment</th>
              <th>Current Value</th>
              <th>ROI</th>
            </tr>
          </thead>
          <tbody className='crypto-body'>
            {
              data.map(i => (
                <tr key={i.id}>
                  <td>{i.id}</td>
                  <td>{i.name}</td>
                  <td>{i.rate}</td>
                  <td>{i.quantity}</td>
                  <td>{i.date}</td>
                  <td>{i.investment}</td>
                  <td>{i.current}</td>
                  <td>{i.roi}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
        {/* <table className='table-container'>
          <tr>
            <td id='s1' className='square' onClick={()=>handleClick(0)}>{state[0]}</td>
            <td id='s2' className='square' onClick={()=>handleClick(1)}>{state[1]}</td>
            <td id='s3' className='square' onClick={()=>handleClick(2)}>{state[2]}</td>
          </tr>
          <tr>
            <td id='s4' className='square' onClick={()=>handleClick(3)}>{state[3]}</td>
            <td id='s5' className='square' onClick={()=>handleClick(4)}>{state[4]}</td>
            <td id='s6' className='square' onClick={()=>handleClick(5)}>{state[5]}</td>
          </tr>
          <tr>
            <td id='s8' className='square' onClick={()=>handleClick(6)}>{state[6]}</td>
            <td id='s9' className='square' onClick={()=>handleClick(7)}>{state[7]}</td>
            <td id='s7' className='square' onClick={()=>handleClick(8)}>{state[8]}</td>
          </tr>
        </table> */}
        {/* <button type='button'  className='but' onClick={()=>startGame()}>Start New Game</button> */}
    </div>
  )
}

export default Crypto